import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

let ScrollTriggerInit = gsap.registerPlugin( ScrollTrigger );

// just some fun If a user goes off the page, then it will ask a question. on focus it will come back
let title = document.title;
let blurMessage = [
  "Baby come back!", 
  "Baby come back!", 
  "Baby come back!", 
  "Fancy a cookie?", 
  "Fancy a cookie?", 
  "Don't you love me anymore?",
  "Don't you love me anymore?",
  "Where did you go?",
  "Where did you go?",
  "Where did you go?"
];

$( window ).on( 'blur', () => {
  let random = Math.floor( ( Math.random() * blurMessage.length ) );
  document.title = blurMessage[ random ];
});

$( window ).on( 'focus', () => { 
  document.title = title; 
});

$( window ).on( 'load', function() {

  ScrollTriggerInit;
  // adding or removes needed class and div to control full width modals
  // ensure that when the back button is pressed we bring back the proper footer and remove modal one
  if ( window.location.href.indexOf( '#!project-planner' ) > -1 ) {
    $( '.nav-primary' ).addClass( 'full-modal-dark' );
    $( '.footer-wrapper-modal' ).show();
    $( '.footer-wrapper' ).hide();

  } else {
    $( '.nav-primary' ).removeClass( 'full-modal-dark' );
    $( '.footer-wrapper' ).show();
    $( '.footer-wrapper-modal' ).hide();
  }

  $( window ).on( 'hashchange', function() {
    if ( 
      window.location.href.indexOf( 'contact' ) > -1 &&
      window.location.href.indexOf( 'project-planner' ) === -1
     ) {
      $( '.nav-primary' ).removeClass( 'full-modal-dark' );
      $( '.footer-wrapper' ).show();
      $( '.footer-wrapper-modal' ).hide();

    } else if ( window.location.href.indexOf( '#!project-planner' ) > -1 ) {
      $( '.nav-primary' ).addClass( 'full-modal-dark' );
      $( '.footer-wrapper-modal' ).show();
      $( '.footer-wrapper' ).hide();
    }
  });

  // change nav to match the modal colors
  window.addEventListener( 'popstate', function() {
    if ( window.location.href.indexOf( '#!project-planner' ) > -1 ) {
      $( '.nav-primary' ).addClass( 'full-modal-dark' );
    } else {
      $( '.nav-primary' ).removeClass( 'full-modal-dark' );
    }
  });
  // check on load if the nav is checked uncheck it for when a user hits the back button

  if ( $( '#toggle-menu' ).is( ':checked' ) ) {
    $( '#toggle-menu' ).prop( 'checked', false );
  }

  // addding no scroll when the menu is open
  const checkbox = document.getElementById( 'toggle-menu' );

  // Hide and remove
  checkbox.addEventListener( 'change', () => {
    $( 'body' ).toggleClass( 'no-scroll' );
    $( '.fixed-socials' ).toggle();
  });

  $( '.scroll-top' ).on( 'click', function() {
    $( 'html, body, .modal' ).scrollTop( 0 );
  });
});
